import { attributedMetricSchema } from "@redotech/redo-marketing-common/attribution";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const commerceAgentPerformance = {
  name: "commerceAgentPerformance" as const,
  input: z
    .object({
      from: zExt.instant().describe("Start instant, inclusive"),
      to: zExt.instant().describe("End instant, exclusive"),
      timeZone: z
        .string()
        .describe(
          "IANA zone the range's days are in; conversations bucket by it",
        ),
      byTrigger: z
        .boolean()
        .describe("Split reach and conversations by the outreach's trigger"),
    })
    .refine((input) => Temporal.Instant.compare(input.from, input.to) < 0, {
      message: "from must be before to",
    }),
  output: z.object({
    /** Orders the team's attribution settings credit to the Commerce Agent. */
    agent: attributedMetricSchema,
    /** Every order in the range, attributed or not. */
    store: attributedMetricSchema,
    reach: z.array(
      z.object({
        triggerKey: z.string().nullable(),
        customersMessaged: z.number(),
        customersReplied: z.number(),
      }),
    ),
    conversationsByDay: z.array(
      z.object({
        /** The store's calendar day, YYYY-MM-DD. */
        day: z.string(),
        triggerKey: z.string().nullable(),
        conversations: z.number(),
      }),
    ),
  }),
};
